import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'studies',
  templateUrl: './studies.component.html',
  styleUrls: ['./studies.component.scss']
})
export class StudiesComponent implements OnInit {

  constructor() { }


  ngOnInit() {

    }
}
